/*
Copyright Captcha, Inc. 2004-2021. All rights reserved.

BotDetect, BotDetect CAPTCHA, Lanap, Lanap CAPTCHA, Lanap BotDetect, 
Lanap BotDetect CAPTCHA, Lanapsoft, Lanapsoft CAPTCHA, 
Lanapsoft BotDetect, Lanapsoft BotDetect CAPTCHA, and Lanap Software 
are trademarks of Captcha, Inc. All other product, brand, and company 
names are mentioned for identification purposes only and are trademarks 
or registered trademarks of their respective owners.

Captcha, Inc. - formerly: Lanapsoft, Inc. / Lanap, Inc.
*/

export default function createScriptElement(source, callback) {
  const script = document.createElement('script');
  script.id = 'bdc_script_include';
  script.src = source;

  if (typeof callback === 'function') {
    script.onload = callback;
  }        
        
  return script;
}
